import { ADD_ACTION, EDIT_ACTION, VIEW_ACTION } from "constants/actions";

export const getHeaderText = (action) => {
  let headerText = "Endorsement Details";

  if (action === EDIT_ACTION) {
    return "Edit Endorsement";
  }

  if (action !== VIEW_ACTION) {
    headerText = "Add New Endorsement";
  }

  return headerText;
};

export const validateTVIEndorsementForm = ({
  action,
  selectedCourses,
  uploadedFiles,
  coursesOptions,
}) => {
  if (uploadedFiles.length === 0) {
    return "Supporting documents cannot be empty";
  }

  const allHaveSlots = selectedCourses.every((course) => course.slots > 0);

  if (!allHaveSlots) {
    return "All selected courses must have slots greater than 0";
  }

  const allWithinAvailableSlots = selectedCourses.every((course) => {
    const courseDetails = coursesOptions.find(
      (item) => item.courseId === course.courseId
    );

    if (!courseDetails) return false;

    const maxSlots =
      action === ADD_ACTION
        ? courseDetails.availableSlots
        : course.oldSlotsValue + course.availableSlots;

    return course.slots <= maxSlots;
  });

  if (!allWithinAvailableSlots) {
    return "All selected courses must have a capacity that does not exceed the available or previously allocated slots.";
  }

  return true;
};
